import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { SIZE } from '../../../constants/size'
import { useBeforeUnload, useBlockNavigation } from '../../../hooks'
import { isDirtyForm } from '../../../utils/formHelpers'
import Modal, { Box, Header, MODAL_HEADER_VARIANT } from '../../Modal'
import { QA_NAME_FORM_MODAL } from '../Form.constants'
import { FormModalConfirmation } from '../FormModalConfirmation'

import * as styles from './FormModalContainer.module.css'

function FormModalContainer({
  Confirmation = FormModalConfirmation,
  boxProps,
  boxSize = SIZE.X_LARGE,
  children,
  confirmationProps = EMPTY_OBJECT,
  files = EMPTY_LIST,
  getIsDirty = isDirtyForm,
  headerProps,
  headerVariant = MODAL_HEADER_VARIANT.CREATE,
  hidden = false,
  isCloseConfirm,
  isFullScreen = false,
  modal,
  modalClassName = styles.modal,
  qaName = QA_NAME_FORM_MODAL,
  setCloseConfirm,
  title,
  onClose,
  onCloseConfirm,
  onIsDirtyChange,
  onMinimize,
  onResize,
  onSubmitConfirm,
}) {
  const { dirty, initialValues, values } = useFormikContext()

  const isDirty = getIsDirty({ dirty, files, initialValues, values })

  useBeforeUnload(isDirty, true)
  useBlockNavigation(isDirty)

  useEffect(() => {
    onIsDirtyChange?.(isDirty)
  }, [isDirty])

  function handleClose() {
    if (isDirty) {
      setCloseConfirm(true)

      return
    }

    onClose()
  }

  function handleConfirmationCancel() {
    onCloseConfirm?.()
    setCloseConfirm(false)
  }

  function handleConfirmationSubmit(confirmationValue) {
    if (onSubmitConfirm) {
      onSubmitConfirm(values, files, confirmationValue)

      return
    }

    onClose()
  }

  return (
    <>
      {modal}
      <Modal
        className={modalClassName}
        hidden={hidden}
        qaName={qaName}
        onClose={handleClose}
      >
        <Box {...boxProps} isFullScreen={isFullScreen} size={boxSize}>
          <Header
            {...headerProps}
            isFullScreen={isFullScreen}
            text={title}
            variant={headerVariant}
            onClose={handleClose}
            onMinimize={onMinimize}
            onResize={onResize}
          />
          {children}
        </Box>
      </Modal>
      {isCloseConfirm ? (
        <Confirmation
          {...confirmationProps}
          onCancel={handleConfirmationCancel}
          onSubmit={handleConfirmationSubmit}
        />
      ) : null}
    </>
  )
}

export default FormModalContainer
